export default (number, args) => {

    number = number.replace(/[^0-9a-zA-Z]+/g, '')
    const min = args[0]
    const max = args[1]

    const invalid = number.length > max || number.length < min

    return !invalid
}